import {default_epp, default_epp_attachment, default_params, default_params_attachments} from './state';

/**
 * Establecer un valor para la variable epps.
 */
export function setEpps(state, epps) {
    state.epps = epps;
}

/**
 * Establecer un valor para la variable epp.
 */
export function setEpp(state, epp) {
    state.epp = epp;
}

/**
 * Establecer un valor para el atributo code de la variable epp.
 */
export function setCodeToEpp(state, code) {
    state.epp.code = code;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditing(state, editing) {
    state.editing = editing;
}

/**
 * Establecer un valor para la variable companies.
 */
export function setCompanies(state, companies) {
    state.companies = companies;
}

/**
 * Establecer el valor por defecto de params.
 */
export function resetParams(state) {
    state.params = default_params();
    state.epps = {data: []};
}

/**
 * Establecer el valor por defecto de epp.
 */
export function resetEpp(state) {
    state.epp = default_epp();
}

/**
 * Establecer un valor para el atributo show la variable modal.
 */
export function setModalShow(state, show) {
    state.modal.show = show;
}

/**
 * Restablecer el valor del atributo page de la variable params.
 */
export function resetPageParams(state) {
    state.params.page = 1;
}

/**
 * Establecer un valor para la variable types.
 */
export function setTypes(state, types) {
    state.types = types;
}

/**
 * Establecer un valor para el atributo show de la variable modal_upload.
 */
export function setShowToModalUpload(state, show) {
    state.upload = {file: null};
    state.modal_upload.show = show;
}

/**
 * Establecer un valor para el atributo show de la variable modal_attachments.
 */
export function setShowToModalAttachments(state, show) {
    state.modal_attachments.show = show;
}

/**
 * Establecer un valor para el atributo show de la variable modal_new_attachment.
 */
export function setShowToModalNewAttachment(state, show) {
    state.modal_new_attachment.show = show;
}

/**
 * Establecer un valor para la variable epp_attachment.
 */
export function setEppAttachment(state, epp_attachment) {
    state.epp_attachment = epp_attachment;
}

/**
 * Establecer el valor por defecto de la variable epp_attachment.
 */
export function resetEppAttachment(state) {
    state.epp_attachment = default_epp_attachment();
}

/**
 * Establecer el valor por defecto de la variable params_attachments.
 */
export function resetParamsAttachments(state) {
    state.params_attachments = default_params_attachments();
}

/**
 * Establecer un valor para la variable attachments.
 */
export function setAttachments(state, attachments) {
    state.attachments = attachments;
}
